import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/#about' },
    { name: 'Services', href: '/#services' },
    { name: 'Quality', href: '/#quality' },
    { name: 'Contact', href: '/contact' }
  ];

  return (
    <footer className="bg-[#0B1C2C] text-white pt-14 sm:pt-16 pb-6 sm:pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          {/* Company Info */}
          <div className="space-y-3 sm:space-y-4">
            <a href="/" className="inline-block group cursor-pointer" data-testid="footer-logo">
              <img
                src="/turbowing-logo-clean.png"
                alt="Turbowing Aviation Logo"
                className="h-20 w-auto sm:h-24 sm:w-auto object-contain transform group-hover:scale-[1.03] transition-transform duration-500"
                style={{
                  filter: 'drop-shadow(0 0 15px rgba(212, 175, 55, 0.3)) brightness(1.05)'
                }}
              />
            </a>
            <p className="text-sm sm:text-base text-white/65 leading-relaxed">
              Your trusted partner in aviation spare parts supply. We deliver quality aircraft components and comprehensive supply chain solutions worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4 text-[#D4AF37] tracking-wide">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-sm sm:text-base text-white/65 hover:text-[#D4AF37] transition-colors duration-300 flex items-center group cursor-pointer"
                  >
                    <span className="w-0 h-0.5 bg-[#D4AF37] group-hover:w-4 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2">
            <h4 className="text-base sm:text-lg font-bold mb-4 text-[#D4AF37] tracking-wide">Contact Us</h4>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start space-x-3 group">
                <MapPin className="w-5 h-5 text-[#D4AF37] mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                <span className="text-sm sm:text-base text-white/65">
                  Techno Hub – 2, Dubai Silicon Oasis, Dubai, UAE
                </span>
              </div>
              <div className="flex items-center space-x-3 group">
                <Phone className="w-5 h-5 text-[#D4AF37] flex-shrink-0 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                <a href="tel:+971542969990" data-testid="footer-phone" className="text-sm sm:text-base text-white/65 hover:text-[#D4AF37] transition-colors duration-300">
                  +971 54 296 9990
                </a>
              </div>
              <div className="flex items-center space-x-3 group">
                <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
                <a href="mailto:sales@turbowingaviation.com" data-testid="footer-email" className="text-sm sm:text-base text-white/65 hover:text-[#D4AF37] transition-colors duration-300 break-all">
                  sales@turbowingaviation.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/55 text-sm">
              © 2026 Turbowing Aviation. All rights reserved.
            </p>
            {/* <div className="flex space-x-6">
              <a href="#" className="text-white/55 hover:text-[#D4AF37] transition-colors duration-300 text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-white/55 hover:text-[#D4AF37] transition-colors duration-300 text-sm">
                Terms of Service
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
